// OK FBI — Squad API client. Uses Bearer tokens stored in localStorage per session.
// KEEP separate from the main JWT-cookie auth to avoid confusion.
import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/squad`;

const KEY_PREFIX = "okfbi_squad_token_";
const LAST_KEY = "okfbi_squad_last_session";

export function saveSquadToken(sessionId, token, role, participantId) {
  if (!sessionId || !token) return;
  const rec = { token, role, participant_id: participantId, saved_at: Date.now() };
  localStorage.setItem(KEY_PREFIX + sessionId, JSON.stringify(rec));
  localStorage.setItem(LAST_KEY, sessionId);
}

export function getSquadToken(sessionId) {
  if (!sessionId) return null;
  try {
    const s = localStorage.getItem(KEY_PREFIX + sessionId);
    return s ? JSON.parse(s) : null;
  } catch { return null; }
}

export function clearSquadToken(sessionId) {
  if (!sessionId) return;
  localStorage.removeItem(KEY_PREFIX + sessionId);
  const last = localStorage.getItem(LAST_KEY);
  if (last === sessionId) localStorage.removeItem(LAST_KEY);
}

export function getLastSquadSession() {
  return localStorage.getItem(LAST_KEY) || null;
}

// Base axios (used for endpoints that rely on the JWT cookie only —
// e.g. sessions/create, join/account). Sends credentials.
export const squadAxios = axios.create({ baseURL: BASE, withCredentials: true });

// Axios instance scoped to a specific session's Bearer token.
export function squadClient(sessionId) {
  const rec = getSquadToken(sessionId);
  const inst = axios.create({ baseURL: BASE, withCredentials: true });
  if (rec?.token) {
    inst.defaults.headers.common.Authorization = `Bearer ${rec.token}`;
  }
  return inst;
}

// Fetch the current squad session state (participants list, state, etc.)
export async function fetchSquadSession(sessionId) {
  const c = squadClient(sessionId);
  const { data } = await c.get(`/sessions/${sessionId}`);
  return data;
}

export async function fetchSquadCase(sessionId) {
  const c = squadClient(sessionId);
  const { data } = await c.get(`/sessions/${sessionId}/case`);
  return data;
}
